import React from 'react';
import urlparam from 'urlparam';
import { connectI18n } from '../../connects';
import APIConnectionWarning from '../../elements/APIConnectionWarning/APIConnectionWarning';
import Blocklink from '../../elements/Blocklink';
import HomeLogo from '../../elements/HomeLogo';
import Scrollable from '../../elements/Scrollable';
import TopBar from '../../elements/TopBar/TopBar';
import Screen from '../Screen';
import LinkedinLogin from './LinkedinLoginButton';
import EmailLoginButton from './EmailLoginButton';
import styles from './authentication.module.scss';
import AppleLoginButton from './AppleLoginButton';

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = { email: urlparam('email') || '' };
    }
    render() {
        var i18n = this.props.i18n,
            header = (
                <>
                    <TopBar returnURL="/" title={i18n['label.login']} />
                    <HomeLogo />
                </>
            ),
            footer = <APIConnectionWarning />;

        return (
            <Screen className="authentication-screen" header={header} footer={footer}>
                <Scrollable>
                    <div
                        style={{
                            padding: '0 0 40px 30px',
                        }}>
                        <LinkedinLogin className={['margins', styles.ActionButton].join(' ')}>{i18n['label.login.by.linkedin']}</LinkedinLogin>
                        <AppleLoginButton className={['margins', styles.ActionButton].join(' ')} />
                        <EmailLoginButton className={['margins', styles.ActionButton].join(' ')} href={`/login/email?email=${this.state.email}`} next>
                            {i18n['label.login.by.email']}
                        </EmailLoginButton>
                    </div>
                    <img
                        src="img/img_1.jpg"
                        style={{
                            display: 'block',
                            width: '100%',
                        }}
                    />
                    <Blocklink className="margins" color="cyan" href="/get_most" next>
                        {i18n['label.about.netwerkapp']}
                    </Blocklink>
                </Scrollable>
            </Screen>
        );
    }
}

export default connectI18n(Login);
